export const STORE_SEARCH_REQUEST = 'STORE_SEARCH_REQUEST';

export const SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS';

export const GET_SEARCH_RESULTS = 'GET_SEARCH_RESULTS';
export const GET_SEARCH_RESULTS_FAIL = 'GET_SEARCH_RESULTS_FAIL';

export const REQUEST_SIGNUP_START = 'REQUEST_SIGNUP_START';
export const REQUEST_SIGNUP_SUCCESS = 'REQUEST_SIGNUP_SUCCESS';
export const REQUEST_SIGNUP_FAIL = 'REQUEST_SIGNUP_FAIL';

export const REQUEST_LOGIN_START = 'REQUEST_LOGIN_START';
export const REQUEST_LOGIN_SUCCESS = 'REQUEST_LOGIN_SUCCESS';
export const REQUEST_LOGIN_FAIL = 'REQUEST_LOGIN_FAIL';

export const REQUEST_SIGNOUT = 'REQUEST_SIGNOUT';
